import React from "react";
import { Options } from "assets/icons";
import "./style.scss";
import Divider from "components/BaseWidgets/divider";
import Avatar from "components/BaseWidgets/Avatar";
import { getUser } from "utils/storage";
import Dropdown from "components/BaseWidgets/dropdown";
import { useDeleteComment } from "hooks/api/useBlogs";
import { useQueryClient } from "@tanstack/react-query";
import AlertNotification from "components/CustomWidgets/alertNotification";

function commentLists({ EachComments, blogId }) {
  const queryClient = useQueryClient();
  const loggedInUser = getUser();
  const loggedInUserId = loggedInUser?.id;

  const authorPic = EachComments?.profile_image;
  const authorName = EachComments?.user_name || "-";
  const commentDate = EachComments?.created_at;
  const message = EachComments?.message;
  const commentUserId = EachComments?.user;
  const commentId = EachComments?.id;

  const { mutate: deleteComment, isPending } = useDeleteComment({
    onSuccess: (data) => {
      AlertNotification("success", "Comment deleted successfully!");
      queryClient.invalidateQueries(["comment-list", blogId]);
    },
  });

  const menuItems = [
    {
      key: "delete",
      label: <span className="delete-comment">Delete Comment</span>,
    },
  ];

  const handleMenuClick = (e) => {
    if (e.key === "delete") {
      deleteComment({ comment_id: commentId });
    }
  };

  return (
    <div className="comment-area">
      <div className="comment-head flex items-center justify-between">
        <div className="commented-by flex items-center gap-2">
          <Avatar url={authorPic} />
          <div className="user-data">
            <span className="fw-600 font-body-xlg">{authorName}</span>
            <span className="fw-400 grey-shade font-body-xlg">
              {commentDate}
            </span>
          </div>
        </div>
        {loggedInUserId === commentUserId && (
          <div className="comment-actions">
            <Dropdown
              items={menuItems}
              label=""
              icon={<Options />}
              trigger={["click"]}
              onClick={handleMenuClick}
            />
          </div>
        )}
      </div>
      <p className="font-body-xxlg fw-400 grey-shade1">{message}</p>
      <Divider className="comment-divider" />
      {/* <div className="comment-reactions flex items-center gap-4">
        <Button variant="round">
          <span className="icon-wrapper">
            <LikePost />
          </span>
        </Button>
        <Button variant="round">
          <span className="icon-wrapper">
            <DislikePost />
          </span>
        </Button>
      </div> */}
    </div>
  );
}

export default commentLists;
